// 商品詳細ページ：ディスクリプションで設定された画像にaltを設定していた場合画像キャプションとして画像下に表示

document.addEventListener("DOMContentLoaded", function () {
  // .Rteクラス内のすべての画像を取得
  var images = document.querySelectorAll(".Rte img");

  images.forEach(function (image) {
    // alt属性が設定されているか確認
    if (image.alt) {
      // altテキストを表示するための新しい要素を作成
      var altText = document.createElement("div");
      altText.className = "image-alt-text";
      altText.textContent = image.alt;

      // 画像の後に新しい要素を挿入
      image.parentNode.insertBefore(altText, image.nextSibling);
    }
  });
});
